import React, { Component } from 'react';
import DayPicker, { LocaleUtils } from 'react-day-picker';
import translates from 'common/helpers/datepickerTranslates';
import langPrefix from 'common/helpers/langPrefix';

function formatMonthTitle(d) {
  return `${d.getFullYear()}年 ${translates.months[d.getMonth()]}`;
}

export default class Daypicker extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const isChinese = langPrefix === 'zh-hant/' || langPrefix === 'zh-hans/';

    return (
      isChinese ? (
        <DayPicker
          {...this.props}
          localeUtils={ { ...LocaleUtils, formatMonthTitle } }
          weekdaysLong={translates.weekdaysLong}
          weekdaysShort={translates.weekdaysShort}
        >
        </DayPicker>
      ) : (
        <DayPicker
          {...this.props}
          months={translates.months}
          weekdaysLong={translates.weekdaysLong}
          weekdaysShort={translates.weekdaysShort}
        >
        </DayPicker>
      )
    )
  };
}

